import { render, staticRenderFns } from "./Cookie.vue?vue&type=template&id=a560548a&scoped=true&"
import script from "./Cookie.vue?vue&type=script&lang=ts&"
export * from "./Cookie.vue?vue&type=script&lang=ts&"
import style0 from "./Cookie.vue?vue&type=style&index=0&id=a560548a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a560548a",
  null
  
)

export default component.exports